import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";

export class GetBankStatementItem {
  @IsString()
  @Expose()
  statementNumber!: string; // "?";
  @IsString()
  @Expose()
  accountNumber!: string; // "95114010100000550285001018";
  @IsString()
  @Expose()
  bankName!: string; // "mBank";
  @IsString()
  @Expose()
  createdAt!: string; //  "2021-12-21T09:39:01";
  @IsString()
  @Expose()
  createdByUserName!: string; // "Katarzyna Migała";
  @IsString()
  @Expose()
  currency!: string; // "PLN";
  @IsString()
  @Expose()
  fromDate!: string; // "2021-12-20T00:00:00";
  @Expose()
  @IsNumber()
  id!: number; // 23638;
  @Expose()
  @IsBoolean()
  isAllItemsAmountLeftZero!: boolean; // true;
  @IsString()
  @Expose()
  officeProfileName!: string; // "WNU Rzeszów";
  @IsString()
  @Expose()
  toDate!: string; // "2021-12-20T00:00:00";
  @Expose()
  @IsNumber()
  recordStampId!: number;
  @IsString()
  @IsOptional()
  @Expose()
  fileId!: string | null;
  @IsBoolean()
  @Expose()
  isEditingLocked!: boolean;
  @IsBoolean()
  @Expose()
  userHasPermissionToEditLocked!: boolean;
}

export class GetBankStatementResponse extends GenericTableResponse<GetBankStatementItem> {
  @Type(() => GetBankStatementItem)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetBankStatementItem>;
}
